import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function LightbulbIcon(props) {
	return (
		<IconBase type="lightbulb" {...props}>
			<path d="M14 14.1052L14.624 13.6563C15.7632 12.8368 16.5 11.5045 16.5 10C16.5 7.51472 14.4853 5.5 12 5.5C9.51472 5.5 7.5 7.51472 7.5 10C7.5 11.5045 8.23684 12.8368 9.37595 13.6563L10 14.1052V16H14V14.1052ZM15.5 14.874V16.5C15.5 17.0523 15.0523 17.5 14.5 17.5H9.5C8.94772 17.5 8.5 17.0523 8.5 16.5V14.874C6.98593 13.7848 6 12.0075 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10C18 12.0075 17.0141 13.7848 15.5 14.874Z" />
			<path d="M9 19H15V19.5C15 20.0523 14.5523 20.5 14 20.5H10C9.44772 20.5 9 20.0523 9 19.5V19Z" />
		</IconBase>
	);
}
LightbulbIcon.propTypes = iconPropTypes;
